import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgOrderdetails = function SvgOrderdetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9216 2H6.75C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H17.25C18.7688 22 20 20.7688 20 19.25V10.0784C20 9.34908 19.7103 8.64961 19.1945 8.13388L13.8661 2.80546C13.3504 2.28973 12.6509 2 11.9216 2ZM11.9216 3.5H6.75C6.05964 3.5 5.5 4.05964 5.5 4.75V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H17.25C17.9404 20.5 18.5 19.9404 18.5 19.25V10.0784C18.5 10.0522 18.4992 10.026 18.4975 10H14.75C13.2312 10 12 8.76878 12 7.25V3.50246C11.974 3.50082 11.9478 3.5 11.9216 3.5ZM13.5 7.25C13.5 7.94036 14.0596 8.5 14.75 8.5H17.4394L13.5 4.56062V7.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.5C8.33579 12.5 8 12.8358 8 13.25 8 13.6642 8.33579 14 8.75 14H12.25C12.6642 14 13 13.6642 13 13.25 13 12.8358 12.6642 12.5 12.25 12.5H8.75ZM8.75 16.5C8.33579 16.5 8 16.8358 8 17.25 8 17.6642 8.33579 18 8.75 18H15.25C15.6642 18 16 17.6642 16 17.25 16 16.8358 15.6642 16.5 15.25 16.5H8.75Z"
  })));
};

export { SvgOrderdetails as ReactComponent };
//# sourceMappingURL=orderdetails.svg.js.map
